export const DATE_FORMAT = 'D MMM [at] HH:mm';

export const GROUP_FILTER_TYPE = 'ACTIVE_FILTER'
export const GROUP_ARCHIVED_FILTER_TYPE = 'ARCHIVED_FILTER'
export const GROUP_SIMPLE_TYPE = 'ACTIVE_SIMPLE'
export const GROUP_ARCHIVED_SIMPLE_TYPE = 'ARCHIVED_SIMPLE'
export const GROUP_TEMP_TYPE = 'TEMP'